<template>
  <main class="home container">
    <div class="row">
      <div class="col-lg-7">
        <NotificationList />
        <TaskList />
      </div>
      <div class="col-lg-5">
        <ProfileTile class="space" />
        <div class="row space">
          <div class="col-6 same-height">
            <MissionTile />
          </div>
          <div class="col-6">
            <InvitationsTile />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <AwardsTile class="space" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ClassificationTile />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import _ from "lodash";
import NotificationList from "../../components/rebuild/NotificationList";
import TaskList from "../../components/rebuild/TaskList";
import ProfileTile from "../../components/rebuild/ProfileTile";
import MissionTile from "../../components/rebuild/MissionTile";
import InvitationsTile from "../../components/rebuild/InvitationsTile";
import AwardsTile from "../../components/rebuild/AwardsTile";
import ClassificationTile from "../../components/rebuild/ClassificationTile";

export default {
  name: "dashboard",
  components: {
    NotificationList,
    TaskList,
    ProfileTile,
    MissionTile,
    InvitationsTile,
    AwardsTile,
    ClassificationTile
  }
};
</script>
<style>
.space {
  margin-bottom: 30px;
}

.same-height {
  display: flex;
  min-width: 50%;
}
</style>
